
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mbbs-abroad",
      function () {
        return require("private-next-pages/mbbs-abroad.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mbbs-abroad"])
      });
    }
  